import React from 'react';

// Crisp vector recreation of the official BBB "Accredited Business" lockup
// (matches the artwork supplied by the business owner). The official BBB
// seal PNG is only 200x65px and looks blurry on modern high-density phone
// screens, so this SVG stays sharp at any size. The torch is vector-traced
// from the official seal file. Still links to the live BBB profile.
export const BBBSeal = ({ className = '', testId }) => {
  return (
    <a
      href="https://www.bbb.org/ca/ab/chestermere/profile/drywall-contractors/sat-drywall-ltd-0017-107532/#sealclick"
      target="_blank"
      rel="nofollow"
      className={`inline-block ${className}`}
      data-testid={testId}
      aria-label="Sat Drywall Ltd. BBB Business Review"
    >
      <svg
        viewBox="0 0 1340 330"
        className="w-full h-auto block"
        role="img"
        aria-label="BBB Accredited Business, A+ Rated by BBB"
      >
        {/* Light card background */}
        <rect x="0" y="0" width="1340" height="330" rx="24" fill="#f6f8fa" />

        {/* Navy pill */}
        <rect x="25" y="40" width="555" height="250" rx="125" fill="#003a6b" />

        {/* Decorative arcs on the pill's right end */}
        <path d="M483 60.7 A108 108 0 0 1 483 269.3" fill="none" stroke="#2c74b8" strokeWidth="20" />
        <path d="M477 83.9 A84 84 0 0 1 477 246.1" fill="none" stroke="#5b9bd5" strokeWidth="13" />

        {/* Original BBB torch (vector-traced from the official seal), white */}
        <g transform="translate(32.4,218) scale(0.0289,-0.0289)" fill="#ffffff">
          <path d="M1801 3804 c-17 -14 -60 -69 -96 -122 -35 -54 -83 -122 -105 -152 -22 -30 -58 -80 -80 -110 -170 -232 -212 -314 -235 -452 -19 -118 -19 -176 1 -301 31 -194 136 -344 356 -509 131 -98 292 -216 328 -241 14 -9 59 -42 100 -72 41 -31 99 -71 128 -90 79 -53 181 -161 211 -225 38 -82 40 -174 7 -271 -29 -85 -32 -112 -13 -127 30 -25 57 1 162 157 57 86 170 245 250 355 170 232 203 289 241 411 24 77 29 107 29 205 -1 163 -38 290 -124 422 -58 89 -127 158 -239 241 -276 202 -350 256 -503 367 -319 231 -358 270 -367 362 -4 38 1 61 18 98 19 41 21 52 10 65 -18 22 -44 19 -79 -11z M1328 2023 c-14 -16 -36 -44 -49 -64 -13 -20 -44 -65 -69 -99 -25 -35 -66 -93 -92 -129 -138 -192 -167 -365 -91 -542 50 -118 120 -197 256 -290 35 -24 100 -71 143 -103 43 -33 139 -104 211 -158 73 -55 138 -108 143 -118 6 -11 13 -41 16 -67 9 -82 13 -92 38 -99 34 -8 63 10 86 56 11 21 41 68 67 105 27 36 70 96 96 133 70 98 123 211 137 292 10 62 9 83 -8 169 -32 154 -86 240 -207 332 -95 71 -207 154 -317 234 -190 138 -249 186 -259 212 -5 13 -9 50 -9 82 0 31 -5 62 -12 69 -20 20 -53 14 -80 -15z M1795 161 c-572 -3 -1048 -10 -1057 -14 -25 -12 -55 -65 -63 -110 l-7 -37 1171 0 c1118 0 1171 1 1171 18 0 29 -43 104 -71 125 -14 10 -43 20 -65 21 -21 1 -507 0 -1079 -3z" />
        </g>

        {/* Pill text */}
        <text
          x="160"
          y="145"
          fontFamily="Arial, Helvetica, sans-serif"
          fontWeight="800"
          fontSize="58"
          fill="#ffffff"
        >
          ACCREDITED
        </text>
        <text
          x="160"
          y="208"
          fontFamily="Arial, Helvetica, sans-serif"
          fontWeight="800"
          fontSize="58"
          fill="#ffffff"
        >
          BUSINESS
        </text>
        <text
          x="160"
          y="252"
          fontFamily="Arial, Helvetica, sans-serif"
          fontWeight="400"
          fontSize="23"
          letterSpacing="2"
          fill="#ffffff"
        >
          BETTER BUSINESS BUREAU
        </text>
        <text
          x="548"
          y="272"
          fontFamily="Arial, Helvetica, sans-serif"
          fontSize="13"
          fill="#ffffff"
        >
          TM
        </text>

        {/* Right text block */}
        <text
          x="615"
          y="150"
          fontFamily="Arial, Helvetica, sans-serif"
          fontWeight="800"
          fontSize="52"
          fill="#1b3a6b"
          textDecoration="underline"
        >
          BBB Accredited Business
        </text>
        <text
          x="615"
          y="245"
          fontFamily="Arial, Helvetica, sans-serif"
          fontWeight="800"
          fontSize="62"
          fill="#6b7280"
        >
          A+
        </text>
        <text
          x="712"
          y="245"
          fontFamily="Arial, Helvetica, sans-serif"
          fontWeight="800"
          fontSize="52"
          fill="#1b3a6b"
          textDecoration="underline"
        >
          Rated by BBB
        </text>
      </svg>
    </a>
  );
};

export default BBBSeal;
